<script>

export default {
  name: 'footer'
}
</script>

<template lang="pug">
    .footer.white-bg-custom#footer
      .container
        .row
          .col-sm-10.col-sm-offset-1.col-md-3
            img.logo(src='/static/images/logo.svg')
            p
              | Medibook® é um serviço de agendamento de consultas e eventos de saúde, criado para atender as demandas de saúde existentes e facilitar o acesso à medicina de forma simples e eficiente. Trata-se de um serviço gratuito, sem custo para usuários e profissionais de saúde.
          .col-sm-10.col-sm-offset-1.col-md-2
            .title Mapa do Site
            ul.padding-0
              a(href='#apresentacao')
                li Apresentação
              a(href='#contato')
                li Contato
              router-link(:to="{name: 'terms.term'}", target="_blank")
                li Termos de Uso
              router-link(:to="{name: 'terms.policy'}", target="_blank")
                li Políticas de Privacidade
          .col-sm-10.col-sm-offset-1.col-md-3
            .title Contato
            .phone
              a(href='tel:4141010994', style='color:inherit;text-decoration:none') 41 4101-0994
            .email contato@medibook.com.br
            .social
                a(href='')
                 .icon.facebook
                    svg(version='1.1', baseprofile='basic', xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink', xmlns:a='http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/', x='0px', y='0px', width='8.842px', height='18.446px', viewbox='0 0 8.842 18.446', overflow='scroll', enable-background='new 0 0 8.842 18.446', xml:space='preserve')
                      defs
                      path(fill='#2071B6', d='M8.842,3.097c-0.575,0-1.128-0.005-1.68,0.003C6.936,3.103,6.708,3.116,6.486,3.157\
                      C6.055,3.236,5.83,3.473,5.818,3.912C5.799,4.635,5.813,5.358,5.813,6.111c0.905,0,1.836,0,2.799,0\
                      C8.571,6.5,8.535,6.858,8.497,7.215C8.432,7.821,8.36,8.426,8.302,9.033c-0.015,0.156-0.072,0.2-0.225,0.198\
                      C7.396,9.224,6.715,9.228,6.034,9.228c-0.076,0-0.152,0-0.252,0c0,3.086,0,6.146,0,9.218c-1.396,0-2.768,0-4.166,0\
                      c0-3.069,0-6.129,0-9.218c-0.413,0-0.801,0-1.189,0C0,9.228,0,9.228,0,8.803c0-0.809,0-1.617,0-2.426c0-0.077,0-0.153,0-0.251\
                      c0.54,0,1.061,0,1.615,0c0-0.102-0.001-0.184,0-0.266C1.63,5.017,1.616,4.172,1.67,3.331c0.048-0.758,0.264-1.476,0.753-2.086\
                      C2.928,0.615,3.607,0.28,4.38,0.143c0.472-0.084,0.957-0.122,1.437-0.132c0.943-0.02,1.887-0.006,2.83-0.006\
                      c0.062,0,0.125,0.008,0.196,0.013C8.842,1.044,8.842,2.056,8.842,3.097z')
                a(href='')
                  .icon.twitter
                    svg(version='1.1', baseprofile='basic', xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink', xmlns:a='http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/', x='0px', y='0px', width='17.446px', height='14.3px', viewbox='0 0 17.446 14.3', overflow='scroll', enable-background='new 0 0 17.446 14.3', xml:space='preserve')
                      defs
                      g
                        path(fill='#00C0F7', d='M0,12.769c1.918,0.104,3.632-0.377,5.15-1.555c-1.076-0.087-1.973-0.511-2.666-1.335\
                        C2.199,9.538,1.983,9.159,1.84,8.705c0.534,0.077,1.041,0.084,1.602-0.083C2.3,8.332,1.474,7.714,0.954,6.716\
                        C0.689,6.208,0.55,5.664,0.571,5.058c0.503,0.244,1.004,0.411,1.578,0.428c-1.604-1.338-1.964-2.928-1.1-4.837\
                        c1.977,2.322,4.439,3.581,7.464,3.8c-0.02-0.181-0.036-0.337-0.055-0.492C8.24,2.175,9.542,0.402,11.312,0.073\
                        c1.248-0.232,2.34,0.084,3.261,0.96c0.1,0.095,0.191,0.095,0.306,0.068c0.666-0.155,1.3-0.394,1.9-0.723\
                        c0.05-0.028,0.102-0.051,0.188-0.094c-0.288,0.829-0.783,1.45-1.473,1.935c0.669-0.046,1.294-0.241,1.906-0.493\
                        c0.015,0.018,0.031,0.036,0.046,0.054c-0.345,0.386-0.681,0.779-1.038,1.153c-0.183,0.192-0.399,0.355-0.611,0.517\
                        c-0.102,0.078-0.131,0.158-0.132,0.285c-0.009,3.477-1.321,6.346-4.047,8.524c-1.408,1.125-3.044,1.742-4.833,1.956\
                        c-2.355,0.282-4.567-0.134-6.621-1.337C0.108,12.846,0.055,12.806,0,12.769z')
        .row
          .hidden-xs.col-sm-10.col-sm-offset-1.copyright
            .pull-left Medibook® - 2018 - Todos os direitos reservados.
            .pull-right
              | 80030-030 Curitiba - PR -
              a(href='tel:4141010994', style='color:inherit;text-decoration:none;display:inline-block') 41 4101-0994

          .hidden-sm.hidden-lg.col-sm-10.col-sm-offset-1.copyright
            .span.text-center Medibook® - 2018 - Todos os direitos reservados. 80030-030 Curitiba - PR -
              a(href='tel:4141010994', style='color:inherit;text-decoration:none;display:inline-block') 41 4101-0994
</template>
<style>
.white-bg-custom {
    padding-top: 50px;
    background: #fff;
    margin-bottom: 0px;
}

#footer {
    color: #666677;
    font-size: 14px;
    font-weight: 300;
    line-height: 180%;
    /* padding-top: 60px; */
    border-bottom: 5px solid #ea1a3c;
    position: relative;
}

#footer #to-top {
    width: 30px;
    height: 30px;
    position: absolute;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0px;
    text-align: center;
    border-radius: 15px;
    background: #2071b6;
    top: -15px;
    left: 0;
    right: 0;
    margin: auto;
    cursor: pointer;
    -webkit-transition: background ease .3s, box-shadow ease .3s, top ease .3s;
    -webkit-transition: background ease .3s, top ease .3s, -webkit-box-shadow ease .3s;
    transition: background ease .3s, top ease .3s, -webkit-box-shadow ease .3s;
    transition: background ease .3s, box-shadow ease .3s, top ease .3s;
    transition: background ease .3s, box-shadow ease .3s, top ease .3s, -webkit-box-shadow ease .3s;
}

#footer #to-top svg * {
    -webkit-transition: fill ease .3s;
    transition: fill ease .3s;
}

#footer #to-top:hover {
    background: #ffffff;
    -webkit-box-shadow: 0px 3px 15px rgba(0, 0, 0, .15);
    box-shadow: 0px 3px 15px rgba(0, 0, 0, .15);
    top: -20px;
}

#footer #to-top:hover svg * {
    fill: #2071b6;
}

#footer .logo {
    width: 160px;
    height: auto;
    margin-bottom: 30px;
}

#footer .title {
    color: #2071b6;
    font-size: 20px;
    font-family: 'Fira Sans', sans-serif;
    font-weight: 500;
    margin-top: 15px;
    margin-bottom: 35px;
    position: relative;
}

#footer .title:after {
    content: "";
    position: absolute;
    width: 15px;
    height: 1px;
    background: #2071b6;
    left: 0;
    bottom: -15px;
}

#footer a {
    color: inherit;
    text-decoration: none;
    display: list-item;
    list-style: none;
}

#footer ul li {
    display: inline-block;
    border-bottom: 1px solid #ffffff;
    -webkit-transition: border ease .3s;
    transition: border ease .3s
}

#footer a:hover li {
    border-bottom: 1px solid #2071b6;
}

#footer .phone {
    font-size: 18px;
    position: relative;
    margin-bottom: 15px;
}

#footer .phone:before {
    width: 12px;
    height: 17px;
    content: "";
    position: absolute;
    background: url(/static/images/icons/phone.png) no-repeat center center;
    top: 5px;
    left: -20px;
}

#footer .email {
    position: relative;
}

#footer .email:before {
    width: 15px;
    height: 11px;
    content: "";
    position: absolute;
    background: url(/static/images/icons/email.png) no-repeat center center;
    top: 7px;
    left: -22px;
}

#footer .social {
    overflow: hidden;
    padding: 30px 5px 15px 5px;
    margin-left: -5px;
}

#footer .social .icon {
    width: 30px;
    height: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    padding: 5px;
    border-radius: 15px;
    background: #ffffff;
    -webkit-box-shadow: 0px 3px 5px rgba(0, 0, 0, .1);
    box-shadow: 0px 3px 5px rgba(0, 0, 0, .1);
    float: left;
    margin-right: 15px;
    -webkit-transition: background ease .3s, box-shadow ease .3s;
    -webkit-transition: background ease .3s, -webkit-box-shadow ease .3s;
    transition: background ease .3s, -webkit-box-shadow ease .3s;
    transition: background ease .3s, box-shadow ease .3s;
    transition: background ease .3s, box-shadow ease .3s, -webkit-box-shadow ease .3s;
}

#footer .social .icon svg * {
    -webkit-transition: fill ease .3s;
    transition: fill ease .3s;
}

#footer .social .icon.facebook:hover {
    background: #2071b6;
    -webkit-box-shadow: 0px 3px 15px rgba(0, 0, 0, .25);
    box-shadow: 0px 3px 15px rgba(0, 0, 0, .25);
}

#footer .social .icon.twitter:hover {
    background: #00c0f7;
    -webkit-box-shadow: 0px 3px 15px rgba(0, 0, 0, .25);
    box-shadow: 0px 3px 15px rgba(0, 0, 0, .25);
}

#footer .social .icon.facebook:hover svg *,
#footer .social .icon.twitter:hover svg * {
    fill: #ffffff;
}

#footer .copyright {
    border-top: 2px solid #f7f7f7;
    margin-top: 45px;
    padding-top: 15px;
    padding-bottom: 15px;
}
#footer {
    padding-bottom: 0px
}
</style>



// WEBPACK FOOTER //
// src/app/auth/terms/policy/components/footer.vue